module.exports = __webpack_public_path__ + "img/Group-61.4bcdfd02.jpg";